import { CreatePlanFeatureRequest, GetAllPlanFeatureReq, PlanFeatureResponse, UpdatePlanFeatureRequest } from "../../interfaces";
import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { apiDelete, apiGet, apiPost, apiPut } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";

export async function getAllPlanFeatureAsync(
    authToken: string,
    payload: GetAllPlanFeatureReq,
    signal?: AbortSignal
): Promise<ApiResponse<PagedResults<PlanFeatureResponse>>> {
    const queryString = buildQuery(payload);
    const apiUrl: string = `/plan-feature?${queryString}`;

    var res = apiGet<ApiResponse<PagedResults<PlanFeatureResponse>>>(
        apiUrl, authToken, signal
    );
    return res;
}

export async function createPlanFeatureAsync(
    authToken: string,
    payload: CreatePlanFeatureRequest,
    signal?: AbortSignal
): Promise<ApiResponse<PlanFeatureResponse>> {
    const apiUrl: string = `/plan-feature`;

    var res = apiPost<ApiResponse<PlanFeatureResponse>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function updatePlanFeatureAsync(
    authToken: string,
    featureId: string,
    payload: UpdatePlanFeatureRequest,
    signal?: AbortSignal
): Promise<ApiResponse<PlanFeatureResponse>> {
    const apiUrl: string = `/plan-feature/${featureId}`;

    var res = apiPut<ApiResponse<PlanFeatureResponse>>(
        apiUrl, payload, authToken, signal
    );
    return res;
}

export async function deletePlanFeatureAsync(
    authToken: string,
    featureId: string,
    signal?: AbortSignal
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/plan-feature/${featureId}`;

    var res = apiDelete<ApiResponse<boolean>>(
        apiUrl, undefined, authToken, signal
    );
    return res;
}